module.exports = __webpack_public_path__ + "static/media/confirm-company-selected.c077874f.svg";